<template>
  <div class="modal fade" id="modalConfirmSignature" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-body modal-confirm-signature">
          <ion-icon name="documents-outline"></ion-icon>
          <p>{{ $t('Aceite de Documento') }}</p>
          <span>{{ $t('Ao clicar em aceitar, você está dando ciência que comprova o recebimento deste documento.') }}</span>
          <div class="buttons">
            <button @click="acceptSignature(2)">
              <span v-if="!loadingCancel">
                {{ $t('Recusar') }}
              </span>
              <div class="loading-btn" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>
            <button @click="acceptSignature(1)">
              <span v-if="!loadingConfirm">
                {{ $t('Aceitar') }}
              </span>
              <div class="loading-btn" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {REQUEST_SERVICE} from "../../../requestConfig";
  import {PUT_ACCEPT_SIGNATURE} from "../../../urlConfig";
  import {UTIL_SERVICE} from "../../../utils";
  import swal from "sweetalert";

  export default {
    name: 'confirm-signature',
    props: {
      documentId: '',
    },
    data() {
      return {
        loadingConfirm: false,
        loadingCancel: false,
      }
    },
    methods: {
      acceptSignature(value) {
        if (this.loadingConfirm || this.loadingCancel) return;
        this.loadingConfirm = value === 1;
        this.loadingCancel = value === 2;
        let browserInfo = UTIL_SERVICE.checkBrowser();

        const getDataLocation = new Promise(function (resolve, reject) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
              enableHighAccuracy: true,
              timeout: 60000,
              maximumAge: 0
            });
          } else {
            reject({doestSupport: true});
          }
        });

        getDataLocation.then((response) => {
          let body = {
            Status: value,
            DeviceId: JSON.parse(window.localStorage.getItem('browserId')),
            DeviceModel: browserInfo.name,
            Id: this.$props.documentId,
            latitude: response.coords.latitude,
            longitude: response.coords.longitude,
          }

          REQUEST_SERVICE.put(PUT_ACCEPT_SIGNATURE, body).then((response) => {
            this.loadingConfirm = false;
            this.loadingCancel = false;
            swal('Sucesso!', response.data, 'success');
            this.closeModal();
          }).catch((reason) => {
            this.loadingConfirm = false;
            this.loadingCancel = false;
            swal('Aviso', "Ocorreu um erro inesperado!", 'error');
          })
        });
      },
      closeModal() {
        this.$emit('clear', null);
        $('#modalConfirmSignature').modal('toggle');
        $('.modal-backdrop').remove();
      }
    }
  }
</script>

<style scoped lang="scss">
 .modal-dialog {
   width: 516px;
   top: 30%;
   transform: translateY(-30%) !important;

   .modal-content {
     width: 516px;
     border-radius: 20px;
   }

   .modal-confirm-signature {
     display: flex;
     flex-direction: column;
     align-items: center;
     gap: 16px;
     padding: 34px 24px 24px;

     p {
       font-size: 24px;
       font-weight: 600;
       margin: 0;
     }

     ion-icon {
       font-size: 54px;
       color: #7E8DA7;
       border: 1px solid currentColor;
       border-radius: 20%;
       padding: 18px;
     }

     span {
       font-size: 16px;
       text-align: center;
       margin: 0 0 12px 0;
       font-weight: 500;
     }

     .buttons {
       display: flex;
       align-items: center;
       gap: 12px;
       place-self: flex-end;
       font-size: 16px;
       font-weight: 500;

       button {
         padding: 8px 24px;
         border-radius: 6px;
         border: none;

         &:first-child {

         }

         &:last-child {
           background: #1b59f8;
           color: #fff;
         }
       }
     }
   }
 }
</style>



// WEBPACK FOOTER //
// src/vue/views/modals/modalConfirmSignature.vue